import {Env} from '../../env';

const api = {
  getSearch: (sessionId: string) => `${Env.Endpoint}/${sessionId}/search/rooms`,
  getDescription: (sessionId: string) => `${Env.Endpoint}/${sessionId}/description/rooms`,
  getRoomDescription: (sessionId: string, roomId: number) => `${Env.Endpoint}/${sessionId}/description/rooms/${roomId}`,
};

export const RoomApi = api;
